import React, { useEffect, useState } from 'react'
import Title from '../../components/common/Title'
import { Topbar } from '../../components/include/Topbar'
import { Postdata } from '../../helpers/api.service'
import HttpService from '../../helpers/httpServices'
import { useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { message } from '../../redux/actions/toastActions'

const SchoolReview = () => {
   const [school, setSchool] = useState({})
   const {id}= useParams();
   const dispatch=useDispatch();
   const [loader,setLoader]=useState(false);

   const fetchData=()=>{
    setLoader(true);
    Postdata(HttpService.admin_school_review,{id:id}).then((res)=>{
        if(res.status===200){
            setSchool(res.data);
        }else{
            dispatch(message(res.message));
        }
        setLoader(false)

    })
   }

   useEffect(()=>{
    fetchData()
   },[])
    return (
        <div>
            <Title name="School Review" />
            <Topbar title="School Review"  aerrow={true}/>
            <div className="p-6 space-y-6 pr-0">
                  <div className="p-6 bg-gray-100 min-h-screen">
      {/* Banner */}
      <div className="relative w-full h-56 rounded-xl overflow-hidden shadow-md">
        <img
          src={school.banner_image}
          alt="Banner"
          className="w-full h-full object-cover"
        />
        {/* <div className="absolute -bottom-12 left-6">
          <img
            src={school.logo}
            alt="School Logo"
            className="w-24 h-24 rounded-full border-4 border-white shadow-lg object-cover"
          />
        </div> */}
      </div>
      

      {/* Main Info */}
      <div className="mt-16 bg-white rounded-lg shadow-md p-6">
         <div className="mb-4">
          <img
            src={school.logo}
            alt="School Logo"
            className="w-24 h-24 rounded-full border-4 border-white shadow-lg object-cover"
          />
        </div>
        <h1 className="text-2xl font-bold text-gray-800">{school.name}</h1>
        <p className="text-gray-500">{school.tagline}</p>

        <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
          <p>
            <span className="font-semibold">Admin Email:</span> {school.email}
          </p>
           <p>
            <span className="font-semibold">Email:</span> {school.school_email}
          </p>
          <p>
            <span className="font-semibold">Admin Phone:</span>{" "}
            {school.mobile_number}
          </p>
           <p>
            <span className="font-semibold">Phone:</span>{" "}
            {school.school_mobile_number}
          </p>
           <p>
            <span className="font-semibold">Sub-Domain:</span>{" "}
            {school.subdomain}
          </p>
          {/* <p>
            <span className="font-semibold">Website:</span> {school.website}
          </p> */}
          <p>
            <span className="font-semibold">Address:</span> {school.addressline},{" "}
            {school.city}, {school.state}, {school.country} - {school.pincode}
          </p>
        </div>
      </div>

      {/* About Section */}
      <div className="mt-6 bg-white rounded-lg shadow-md p-6">
        <h2 className="text-lg font-bold text-gray-800 mb-2">About</h2>
        <p className="text-gray-600">{school.about}</p>
        <img
          src={school.about_image}
          alt="About"
          className="mt-4 rounded-lg shadow-md w-full max-h-64 object-cover"
        />
      </div>

      {/* History Section */}
      <div className="mt-6 bg-white rounded-lg shadow-md p-6">
        <h2 className="text-lg font-bold text-gray-800 mb-2">History</h2>
        <p className="text-gray-600">{school.history}</p>
        <img
          src={school.history_image}
          alt="History"
          className="mt-4 rounded-lg shadow-md w-full max-h-64 object-cover"
        />
      </div>

      {/* Why Us Section */}
      <div className="mt-6 bg-white rounded-lg shadow-md p-6">
        <h2 className="text-lg font-bold text-gray-800 mb-2">Why Us</h2>
        <p className="text-gray-600">{school.why_us}</p>
        <img
          src={school.why_us_image}
          alt="Why Us"
          className="mt-4 rounded-lg shadow-md w-full max-h-64 object-cover"
        />
      </div>

      {/* Pictures */}
      {/* <div className="mt-6 bg-white rounded-lg shadow-md p-6">
        <h2 className="text-lg font-bold text-gray-800 mb-4">Gallery</h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
          {school.pictures.map((pic, idx) => (
            <img
              key={idx}
              src={pic}
              alt={`pic-${idx}`}
              className="rounded-lg object-cover w-full h-32 shadow-sm"
            />
          ))}
        </div>
      </div> */}
    </div>

            </div>
        </div>
    )
}

export default SchoolReview
